
import React from 'react';
import { CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, Save } from 'lucide-react';
import { Loader2 } from 'lucide-react';

interface RevenueSplitHeaderProps {
  setIsAdding: React.Dispatch<React.SetStateAction<boolean>>;
  isAdding: boolean;
  handleSave: () => Promise<void>;
  isSaving: boolean;
}

const RevenueSplitHeader: React.FC<RevenueSplitHeaderProps> = ({
  setIsAdding,
  isAdding,
  handleSave,
  isSaving
}) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <CardTitle>Revenue Split Configuration</CardTitle>
        <CardDescription>Configure revenue sharing between Master License and Resellers</CardDescription>
      </div>
      <div className="flex space-x-2">
        <Button 
          variant="outline" 
          onClick={() => setIsAdding(!isAdding)}
          className="flex items-center"
          disabled={isSaving}
        >
          <Plus className="h-4 w-4 mr-2" />
          Add Split Tier
        </Button>
        <Button 
          onClick={handleSave} 
          disabled={isSaving}
          className="flex items-center"
        >
          {isSaving ? (
            <>
              <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              Saving...
            </>
          ) : (
            <>
              <Save className="h-4 w-4 mr-2" />
              Save Changes
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default RevenueSplitHeader;
